export {PropertyRules} from "./property-rules.model";
export type {PropertyRulesInstance, PropertyRule} from "./property-rules.model";

export {PropertyDetails} from "./property-details.model";
export type {PropertyDetailsInstance} from "./property-details.model";
